import { GraphUtils } from '@helpers/graph.helper';
import { Sensor, dataChart } from './sensor';
import { Router } from '@angular/router';

export class LevelSensor extends Sensor {
  public pressureChart: any;

  private pressSensor: any[];

  constructor(router: Router, url: string, alerstActive: boolean) {
    super(router, url, alerstActive);
    this.pressureChart = null;

    this.pressSensor = [[], [], []];
  }

  public hasPressSensor(pos: number): boolean {
    return this.pressSensor[pos - 1].length > 0;
  }

  public getPressSensor(pos: number): any {
    const realPos: number = this.pressSensor[pos - 1].length - 1;
    return this.pressSensor[pos - 1][realPos][1] ?? null;
  }

  public prepareData(): void {
    for (const element of this.data) {
      const date = new Date(element.date);
      this.pressSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.preassure,
      ]);
    }
  }

  public setCharts(): void {
    this.pressureChart = this.getConfigChar(
      'level',
      this.getChartSeries('Nivel', this.pressSensor),
      this.getRanges('9_preassure'),
      this.getLimits('9_preassure')
    );
  }

  public static getVariables(): any[] {
    return [
      { title: 'Nivel de agua', value: '9_preassure' }
    ];
  }

}